/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const CREATEEDUCATION= createAsyncThunk(
  "createEducation/createEducation",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const createEducationSlice = createSlice({
  name: "createEducationSlice",
  initialState: {
    createEducation: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfcreateEducation: (state) => {
        state.createEducation.loading = false
        state.createEducation.error = false
        state.createEducation.data = []
        state.createEducation.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CREATEEDUCATION.fulfilled, (state, action) => {
      state.createEducation = {
        ...state.createEducation,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEEDUCATION.pending, (state, action) => {
      state.createEducation = {
        ...state.createEducation,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEEDUCATION.rejected, (state, action) => {
      state.createEducation = {
        ...state.createEducation,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const createEducationAction = {
    CREATEEDUCATION,
};

export { createEducationAction };
export default createEducationSlice.reducer;
export const {setInitialStateOfcreateEducation} = createEducationSlice.actions